import * as $ from 'jquery';

export class Notif {
    static show(type = 'success', message = '') {
        const $notif = $('.global-notif');
        const $notifBody = $('.notif-body');
        const $message = $notif.find('.notif-message');
        const $successIcon = $notif.find('.notif-succsess-icon');
        const $failedIcon = $notif.find('.notif-failed-icon');

        // reset
        $successIcon.addClass('hidden');
        $failedIcon.addClass('hidden');
        $notifBody.removeClass('success');
        $notifBody.removeClass('error');
        $notifBody.removeClass('warning');


        // type
        if (type === 'success') {
            $successIcon.removeClass('hidden');
            $notifBody.addClass('success');
        } else {
            $failedIcon.removeClass('hidden');
            $notifBody.addClass('error');
        }

        // message
        $message.text(message);

        // show
        $notif.removeClass('hidden');

        //hide after 4 sec
        setTimeout(() => {
            $notif.addClass('hidden');
        }, 4000);

    }
    static confirm( message = 'Are you sure?') {
        return new Promise((resolve, reject) => {
            const $notif = $('.global-notif');
            const $notifBody = $('.notif-body');
            $notif.removeClass('hidden');
            $notifBody.addClass('warning');
            $('.notif-warning').text(message);
            const $actions = $notif.find('.notif-actions');
            $actions.html(`
            <button class="notif-btn notif-yes btn-yes">Yes</button>
            <button class="notif-btn notif-no btn-no">No</button>
        `);

            $actions.find('.btn-yes').one('click', () => {
                $notif.addClass('hidden');
                $actions.empty();
                resolve(true);
            });

            $actions.find('.btn-no').one('click', () => {
                $notif.addClass('hidden');
                $actions.empty();
                reject(false);
            });
        });
    }
    static init() {
        $(document).on('click', '.notif-close-btn-js', () => {
            $('.global-notif').addClass('hidden');
        });
    }
}